export const getFirebaseErrorMessage = (error) => {
  // Extract the error code from the Firebase error message
  const errorCode = error?.code || '';

  // Map of Firebase error codes to user-friendly messages
  const errorMessages = {
    'auth/email-already-in-use': 'This email address is already registered. Please try logging in instead.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/operation-not-allowed': 'Email/password accounts are not enabled. Please contact support.',
    'auth/weak-password': 'Please choose a stronger password. It should be at least 6 characters long.',
    'auth/user-disabled': 'This account has been disabled. Please contact support.',
    'auth/user-not-found': 'No account found with this email. Please check your email or register.',
    'auth/wrong-password': 'The password you entered is incorrect. Please try again.',
    'auth/too-many-requests': 'Too many failed attempts. Please try again later.',
    'auth/network-request-failed': 'Network error. Please check your internet connection.',
    'auth/popup-closed-by-user': 'The sign-in window was closed before completing the process.',
    'auth/cancelled-popup-request': 'The sign-in process was cancelled.',
    'auth/popup-blocked': 'The sign-in popup was blocked by your browser. Please allow popups for this site.',
    'auth/account-exists-with-different-credential':
      'An account already exists with the same email address but different sign-in credentials.',
    'auth/credential-already-in-use': 'This account is already in use on a different device.',
    'auth/requires-recent-login': 'Please log out and log in again to perform this action.',
    'auth/invalid-credential': 'Invalid login credentials. Please check your email and password.',
    'auth/invalid-verification-code': 'Invalid verification code. Please try again.',
    'auth/invalid-verification-id': 'Invalid verification ID. Please try again.',
    'auth/missing-verification-code': 'Please enter the verification code.',
    'auth/missing-verification-id': 'Verification ID is missing. Please try again.',
    'auth/quota-exceeded': 'Service quota exceeded. Please try again later.',
    'auth/unauthorized-domain': 'This domain is not authorized for OAuth operations.'
  };

  // For debugging
  // console.log('Firebase error:', error);
  // console.log('Error code:', errorCode);

  // Return the user-friendly message if available, otherwise return a generic message
  return errorMessages[errorCode] || 'An error occurred. Please try again.';
};
